(function () {
  'use strict';

  if (window.MCubeWishlist) return;
  if (!window.MCubeCore) return;

  var core = window.MCubeCore;
  var emitter = core.createEmitter();
  var STORAGE_KEY = core.STORAGE_KEYS.wishlist;
  var CHANGE_EVENT = 'mcube:wishlist:change';
  var initialState = {
    version: core.STORAGE_VERSION,
    updatedAt: 0,
    items: [],
    tombstones: {}
  };

  var storedState = core.getStorageItem(STORAGE_KEY);
  var legacyState = !storedState && !core.isAccountSyncActive() && core.LEGACY_STORAGE_KEYS
    ? core.getStorageItem(core.LEGACY_STORAGE_KEYS.wishlist)
    : null;
  var state = sanitizeState(storedState
    ? core.readVersionedState(STORAGE_KEY, initialState)
    : core.safeJsonParse(legacyState, initialState));

  if (!storedState && legacyState) {
    state = sanitizeState(core.writeVersionedState(STORAGE_KEY, state));
  }

  function sanitizeState(source) {
    var next = Object.assign({}, initialState, source || {});
    var items = Array.isArray(next.items) ? next.items : [];
    var tombstones = next.tombstones && typeof next.tombstones === 'object' && !Array.isArray(next.tombstones)
      ? next.tombstones
      : {};
    var cleanTombstones = {};
    var deduped = [];
    var seen = {};

    Object.keys(tombstones).forEach(function (key) {
      var deletedAt = Number(tombstones[key]);
      if (key && Number.isFinite(deletedAt) && deletedAt > 0) cleanTombstones[key] = deletedAt;
    });

    items.forEach(function (item) {
      var reference = core.createReference(item);
      if (!reference) return;

      var key = core.getReferenceKey(reference);
      if (!key || seen[key]) return;
      if (cleanTombstones[key] >= reference.addedAt) return;

      seen[key] = true;
      deduped.push(reference);
    });

    next.items = deduped;
    next.tombstones = cleanTombstones;
    next.updatedAt = Number(next.updatedAt) || 0;
    next.version = core.STORAGE_VERSION;

    return next;
  }

  function persist(source) {
    state = sanitizeState(core.writeVersionedState(STORAGE_KEY, state));
    notify(source || 'internal');
    return getSnapshot();
  }

  function notify(source) {
    var payload = {
      items: getAll(),
      count: count(),
      updatedAt: state.updatedAt,
      source: source || 'internal'
    };

    emitter.emit(payload);
    core.dispatchDocumentEvent(CHANGE_EVENT, payload);
  }

  function findIndex(reference) {
    var key = core.getReferenceKey(reference);

    return state.items.findIndex(function (item) {
      return core.getReferenceKey(item) === key;
    });
  }

  function getAll() {
    return core.clone(state.items);
  }

  function getSnapshot() {
    return {
      version: state.version,
      updatedAt: state.updatedAt,
      items: getAll(),
      tombstones: core.clone(state.tombstones)
    };
  }

  function has(input) {
    var reference = core.createReference(input);
    if (!reference) return false;
    return findIndex(reference) > -1;
  }

  function add(input) {
    var reference = core.createReference(input);
    if (!reference) return getSnapshot();
    if (has(reference)) return getSnapshot();

    delete state.tombstones[core.getReferenceKey(reference)];
    state.items.unshift(reference);
    return persist('add');
  }

  function remove(input) {
    var reference = core.createReference(input);
    if (!reference) return getSnapshot();

    var index = findIndex(reference);
    if (index === -1) return getSnapshot();

    state.tombstones[core.getReferenceKey(reference)] = core.now();
    state.items.splice(index, 1);
    return persist('remove');
  }

  function toggle(input) {
    if (has(input)) {
      return remove(input);
    }

    return add(input);
  }

  function clear() {
    if (!state.items.length) return getSnapshot();
    state.items.forEach(function (item) {
      state.tombstones[core.getReferenceKey(item)] = core.now();
    });
    state.items = [];
    return persist('clear');
  }

  function replaceSnapshot(snapshot, source) {
    state = sanitizeState(snapshot);
    core.setStorageItem(STORAGE_KEY, JSON.stringify(state));
    notify(source || 'sync');
    return getSnapshot();
  }

  function refresh(input) {
    var reference = core.createReference(input);
    if (!reference || reference.type !== 'scene') return getSnapshot();
    var index = findIndex(reference);
    if (index === -1) return getSnapshot();

    var current = state.items[index];
    var next = Object.assign({}, reference, { addedAt: current.addedAt });
    if (JSON.stringify(current) === JSON.stringify(next)) return getSnapshot();
    state.items[index] = next;
    return persist('refresh');
  }

  function count(type) {
    if (!type) return state.items.length;
    return state.items.filter(function (item) { return core.getReferenceType(item) === type; }).length;
  }

  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) return;

    var nextState = sanitizeState(core.safeJsonParse(event.newValue, initialState));
    state = nextState;
    notify('storage');
  });

  window.MCubeWishlist = {
    CHANGE_EVENT: CHANGE_EVENT,
    add: add,
    clear: clear,
    count: count,
    createProductReference: core.createProductReference,
    createSceneReference: core.createSceneReference,
    getAll: getAll,
    getSnapshot: getSnapshot,
    has: has,
    refresh: refresh,
    replaceSnapshot: replaceSnapshot,
    remove: remove,
    subscribe: emitter.subscribe,
    toggle: toggle
  };

  window.WishlistStore = window.MCubeWishlist;
})();
